/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Alert, Typography, Skeleton } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import * as actions from "./actions";
import { fetchCurrentLocationRequest } from "../Location/actions";
import { getAppointmentReasons, getReasonsLoadingState } from "./reducers";
import RenderReasonList from "./RenderReasonList";
import * as bookingActions from "../Booking/actions";
import { getAvailabilityRequests } from "../Booking/reducers";
import { isEmpty } from "lodash";

const ReasonsLoadingSkeleton = () => (
	<div>
		{[1, 2, 3, 4].map((i) => (
			<div
				key={i}
				style={{
					padding: '16px 0',
					borderBottom: '1px solid #f0f0f0',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					gap: 12,
				}}
			>
				<div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', flex: 1 }}>
					<Skeleton.Avatar active shape="square" size={48} style={{ borderRadius: 8 }} />
					<div style={{ flex: 1 }}>
						<Skeleton.Input active size="small" style={{ width: 160, marginBottom: 8 }} />
						<Skeleton.Input active size="small" style={{ width: 80, height: 14 }} />
					</div>
				</div>
				<Skeleton.Button active shape="round" size="default" style={{ width: 70 }} />
			</div>
		))}
	</div>
);

const Reasons = ({
	fetchCatalogueItemsRequest,
	match,
	practiceId,
	practitionerId,
	reasons,
	toggleItem,
	selectItem,
	unselectItem,
	themeColor,
	availabilityRequests,
	reasonsLoading,
}) => {
	const [filteredReasons, setFilteredReasons] = React.useState(reasons);
	const dispatch = useDispatch();

	const currentLocation = useSelector(
		(state) => state.locations.currentLocation,
	);

	const bookingMessageContent = useSelector(
		(state) => state.locations.currentLocation?.bookingMessageContent,
	);
	const bookingMessageTitle = useSelector(
		(state) => state.locations.currentLocation?.bookingMessageTitle,
	);
	const allowDismissableBookingMessage = useSelector(
		(state) => state.locations.currentLocation?.allowDismissableBookingMessage,
	);
	const standaloneMode = useSelector(
		(state) => state.locations.currentLocation?.standaloneMode,
	);

	useEffect(() => {
		if (practiceId) {
			fetchCatalogueItemsRequest(practiceId);
		}
	}, [fetchCatalogueItemsRequest, practiceId]);

	useEffect(() => {
		if (isEmpty(currentLocation)) {
			dispatch(fetchCurrentLocationRequest(practiceId));
		}
	}, [currentLocation, practiceId, dispatch]);

	useEffect(() => {
		if (practitionerId) {
			const filteredReasons = reasons.filter((reason) =>
				reason.displayPractitioners
					? reason.displayPractitioners.map((practitioner) => practitioner.id.toString()).includes(practitionerId)
					: true,
			);
			setFilteredReasons(filteredReasons);
		} else {
			setFilteredReasons(reasons);
		}
	}, [reasons, practitionerId]);

	if (reasonsLoading) {
		return <ReasonsLoadingSkeleton />;
	}

	return (
		filteredReasons && (
			<>
				<RenderReasonList
					reasons={filteredReasons}
					selectItem={selectItem}
					themeColor={themeColor}
					unselectItem={unselectItem}
					toggleItem={toggleItem}
					availabilityRequests={availabilityRequests}
					practitionerId={practitionerId}
					multiSelect={false}
				/>
				{/* Only show booking message in embed mode - standalone mode shows it in sidebar */}
				{bookingMessageContent && !standaloneMode && (
					<Alert
						icon={<InfoCircleOutlined />}
						style={{
							background: "#fff",
							border: "1px solid #d9d9d9",
							marginTop: 20,
						}}
						showIcon
						message={
							<Typography.Text>{bookingMessageTitle}</Typography.Text>
						}
						description={bookingMessageContent}
						closable={allowDismissableBookingMessage}
					/>
				)}
			</>
		)
	);
};

const mapStateToProps = (state) => ({
	reasons: getAppointmentReasons(state.appointmentReasons),
	availabilityRequests: getAvailabilityRequests(state.booking),
	reasonsLoading: getReasonsLoadingState(state.appointmentReasons),
});

export default connect(mapStateToProps, { ...actions, ...bookingActions })(
	Reasons,
);
